import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { AGENT_STATUS_OPTIONS } from "../../../../../constants/peopleData";
import AgentSuspendedPill from "../AgentSuspendedPill";

export default function AgentPresenceChip({ presence, label }) {
  if (presence === "suspended") {
    return <AgentSuspendedPill />;
  }

  const opt = AGENT_STATUS_OPTIONS.find((o) => o.value === presence);
  const displayLabel = label || opt?.label || presence || "—";

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        height: 24,
        px: 1.25,
        borderRadius: "20px",
        border: "1px solid #C5CED6",
        background: "#F9FAFA",
        boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
        flexShrink: 0,
      }}
    >
      <Box
        component="span"
        sx={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          bgcolor: opt?.dot || "#93A1B0",
          flexShrink: 0,
        }}
      />
      <Typography
        sx={{
          color: "#405261",
          fontFamily: "Inter",
          fontSize: 12,
          fontWeight: 500,
          lineHeight: 1,
          whiteSpace: "nowrap",
        }}
      >
        {displayLabel}
      </Typography>
    </Box>
  );
}
